import type { ThemeOverride } from '@chakra-ui/react'
import { extendTheme } from '@chakra-ui/react'
import { DefaultBrightTheme } from './default'

export const brightTheme: ThemeOverride = extendTheme(DefaultBrightTheme)
